import { useEffect, useState } from 'react';
import AboutMobile from './AboutMobile';
import AboutDesktop from './AboutDesktop';

export default function About() {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkWidth = () => setIsDesktop(window.innerWidth >= 768);
    checkWidth();
    window.addEventListener('resize', checkWidth);
    return () => window.removeEventListener('resize', checkWidth);
  }, []);

  return isDesktop ? <AboutDesktop /> : <AboutMobile />;
}
